import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { Letter } from "../model/letter";
import { Injectable } from "@angular/core";
import { SearchComplaintRequest } from "../model/requests/searchComplaintRequest";
import { ComplaintGrid } from "app/complaint/models/complaintGrid";
import { ImageAccessUrlViewModel } from "../model/ImageAccessUrlViewModel";

@Injectable()
export class LetterService {
    constructor(
        private http: GlobalService,
        private entityService: EntityService
    ) { }

    getById(id: number): Observable<Letter> {
        const url = `CertifiedLegalLetter/${id}`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<Letter>(res))
            .map((dataItem) => this.entityService.copy(dataItem, new Letter()));
    }

    getAll(): Observable<Letter[]> {
        const url = `CertifiedLegalLetter`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<Letter[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const letter = new Letter();
                    return this.entityService.copy(dataItem, letter);
                });
            });
    }

    getComplaints(searchRequest: SearchComplaintRequest): Observable<ComplaintGrid[]> {
        const url = `CertifiedLegalLetter/Complaints`;
        return this.http
            .post(url, searchRequest)
            .map((res) => this.entityService.extractData<ComplaintGrid[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const complaint = new ComplaintGrid(dataItem.date);
                    return this.entityService.copy(dataItem, complaint);
                });
            });
    }

    create(createRequest: Letter): Observable<Letter> {
        const url = `CertifiedLegalLetter/add`;
        console.log(createRequest);
        return this.http.post(url, createRequest)
            .map((res) => this.entityService.extractData<Letter>(res))
            .map((dataItem) => this.entityService.copy(dataItem, new Letter()));
    }

    saveFile(letterId: number, file: File, documentType: string): Observable<boolean> {
        const url = `CertifiedLegalLetter/AddFilesToLetter/${letterId}`;
        let headers = new Headers();
        headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Access-Control-Allow-Headers', "X-Requested-With, Content-Type, Origin, Authorization, Accept, Client-Security-Token, Accept-Encoding");

        const formData: FormData = new FormData();
        formData.append('File', file, file.name); // 'File' es el nombre del campo de archivo
        formData.append('LetterId', letterId.toString());  // Asegúrate de que el nombre coincida con el backend
        formData.append('DocumentType', documentType);  // Agregar DocumentType

        return this.http.postFile(url, formData, headers)
            .map(response => {
                // Verificar la respuesta del backend
                if (response.toString().length === 2) { // Ajusta esto según la respuesta que devuelve el backend
                    return true;
                } else {
                    return false;
                }
            });
    }

    GetImageAccessUrl(id: number): Observable<ImageAccessUrlViewModel> {

        const url = `CertifiedLegalLetter/${id}/access-url`;

        return this.http
            .get(url)
            .map(res => this.entityService.extractData<any>(res))
            .map(data => {
                const result = new ImageAccessUrlViewModel();
                result.url = data.url;
                result.expiresOn = data.expiresOn;
                result.isPrivate = data.isPrivate;
                return result;
            });
    }


}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/letter.service.ts